import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Target, TrendingUp, Award, Zap } from 'lucide-react';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: Target,
    title: 'Fácil de seguir',
    desc: 'Instrucciones claras para cada día. No tenés que pensar qué hacer.'
  }, {
    icon: TrendingUp,
    title: 'Sistema progresivo',
    desc: 'Avanzás de a poco, sin forzarte. Tu cuerpo se adapta naturalmente.'
  }, {
    icon: Award,
    title: 'Resultados reales',
    desc: 'Más de 500 personas ya corrieron sus primeros 5K con este método.'
  }, {
    icon: Zap,
    title: 'No necesitas motivación',
    desc: 'El sistema está diseñado para que sigas adelante incluso sin ganas.'
  }];
  return <section ref={ref} className="py-20 px-4 bg-navy" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <motion.h2 className="text-4xl md:text-5xl font-black mb-16 text-center" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-15">
          Por qué funciona cuando{' '}
          <span className="text-accent" data-id="element-16">todo lo demás falló</span>
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-17">
          {benefits.map((benefit, i) => <motion.div key={i} className="bg-navy-light p-8 rounded-2xl border border-accent/20 hover:border-accent/50 transition-all" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2 + i * 0.1
        }} whileHover={{
          scale: 1.02
        }} data-id="element-18">
              <div className="bg-accent/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-19">
                <benefit.icon className="text-accent" size={32} data-id="element-20" />
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-21">{benefit.title}</h3>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-22">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}